import React, { forwardRef } from 'react';

const InfoIcon = forwardRef((props, ref) => {
  const { ...otherProps } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...otherProps}
    >
      <g clipPath="url(#clip0_24449_5091)">
        <path
          d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0V0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z"
          fill="#2F3037"
        />
        <path
          d="M7.99983 6.66687H7.33317C7.15636 6.66687 6.98679 6.73711 6.86177 6.86213C6.73674 6.98716 6.6665 7.15673 6.6665 7.33354C6.6665 7.51035 6.73674 7.67992 6.86177 7.80494C6.98679 7.92997 7.15636 8.0002 7.33317 8.0002H7.99983V12.0002C7.99983 12.177 8.07007 12.3466 8.1951 12.4716C8.32012 12.5966 8.48969 12.6669 8.6665 12.6669C8.84331 12.6669 9.01288 12.5966 9.1379 12.4716C9.26293 12.3466 9.33317 12.177 9.33317 12.0002V8.0002C9.33317 7.64658 9.19269 7.30744 8.94264 7.05739C8.69259 6.80735 8.35346 6.66687 7.99983 6.66687Z"
          fill="#2F3037"
        />
        <path
          d="M8 5.33313C8.55228 5.33313 9 4.88541 9 4.33313C9 3.78085 8.55228 3.33313 8 3.33313C7.44772 3.33313 7 3.78085 7 4.33313C7 4.88541 7.44772 5.33313 8 5.33313Z"
          fill="#2F3037"
        />
      </g>
      <defs>
        <clipPath id="clip0_24449_5091">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

InfoIcon.defaultProps = {
  style: {
    color: '#93A3C0',
  },
};

export default InfoIcon;
